import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import * as Yup from 'yup';
import { ERROR_MSG, handleKeyPressAlphabets } from '../../CommonUtilities/Validations/RegularExpAndVar';
import { IoIosArrowDown } from 'react-icons/io';
import Select from 'react-select';
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls';
import { FaRegEdit } from 'react-icons/fa';
import Sweetalert from '../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { BiTrash } from 'react-icons/bi';
import Swal from 'sweetalert2';
import { CommonAxiosGetNotRead, CommonAxiosPost } from '../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../CommonUtilities/CommonHeading/CommonPageHeading';

export default function AddService() {
    const [showRoles, setRoles] = useState([]);
    function getRoles() {
        let linkurl = config.url.DSC_URL + 'user-roles'
        CommonAxiosGetNotRead(linkurl).then((response) => {
            if (response?.data?.status === true) {
                setRoles(response?.data?.roles)
            }
            else {
                setRoles([]);
            }
        });
    }
    const [showParent, setParent] = useState([]);
    function getParentApi() {
        let url = config.url.DSC_URL + "user-services";
        CommonAxiosGetNotRead(url).then((res) => {
            if (res.data.status === true) {
                setParent(res.data.services);
            } else {
                setParent([]);
            }
        })
    }

    const [selectedOptions, setSelectedOptions] = useState([]);
    let showRoleService = [];
    async function editService(rowData) {
        showRoleService = [];
        setSelectedOptions([]);
        let url = config.url.DSC_URL + "roles-for-service?serviceId=" + rowData.service_id;
        await CommonAxiosGetNotRead(url).then((res) => {
            if (res.data !== undefined) {
                showRoleService = (res.data.map(({ display_name: label, role_id: value }) => ({ label, value })));
            }
        })
        setSelectedOptions(showRoleService);

        Formik.setFieldValue('roles', showRoleService.map((option) => option.value));
        Formik.setFieldValue("serviceId", rowData.service_id);
        Formik.setFieldValue("serviceName", rowData.service_name);
        Formik.setFieldValue("parent", rowData.parent_id);
        Formik.setFieldValue("priority", rowData.priority);
        Formik.setFieldValue("target", rowData.target);
        Formik.setFieldValue("description", rowData.description);
    }

    const deleteFunction = async (rowData) => {
        let url = config.url.DSC_URL + "delete-roles-services?serviceId=" + rowData.service_id;

        Swal.fire({
            title: "Do you want to delete ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                CommonAxiosPost(url)
                    .then((res) => {
                        if (res?.data?.status === true) {
                            Sweetalert(res.data.sdesc, "success");
                            getParentApi();
                        } else {
                            Sweetalert(res.data.sdesc, "error");
                        }
                    })
            }
        });
    };
    const DisableFunction = async (rowData, rstatus) => {
        let url = config.url.DSC_URL + "disable-service?serviceId=" + rowData.service_id;
        let values = { status: rstatus }
        Swal.fire({
            title: rstatus === true ? 'Do you want to activate' : 'Do you want to De-activate',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                CommonAxiosPost(url, values)
                    .then((res) => {
                        if (res?.data?.status === true) {
                            Sweetalert(res.data.sdesc, "success");
                            getParentApi();
                        } else {
                            Sweetalert(res.data.sdesc, "error");
                        }
                    })
            }
        });
    };


    const submitDetails = async (submitvalues, resetForm) => {
        try {
            const res = await CommonAxiosPost(config.url.DSC_URL + "add-service", submitvalues);
            if (res.data.status === true) {
                Sweetalert(res.data.sdesc, 'success').then((res) => {
                    if (res.isConfirmed === true) {
                        getParentApi()
                        resetForm()
                        setSelectedOptions([])
                    }
                })
            }
            else if (res.data.status === false) {
                Sweetalert(res.data.sdesc, 'error')
            }
        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }

    };

    const ValidationSchema = Yup.object().shape({
        serviceName: Yup.string().required(ERROR_MSG).nullable(),
        parent: Yup.string().required(ERROR_MSG).nullable(),
        priority: Yup.string().required(ERROR_MSG).nullable(),
        target: Yup.string().required(ERROR_MSG).nullable(),
        description: Yup.string().required(ERROR_MSG).nullable(),
        roles: Yup.array().min(1, 'Please select at least one role').required(ERROR_MSG).nullable(),
    });
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            entryBy: 'admin',
            //loginReducer.userId,
            serviceId: null,
            serviceName: '',
            parent: '',
            priority: '',
            target: '',
            description: '',
            roles: []
        },
        validationSchema: ValidationSchema,
        onSubmit: (values, { resetForm }) => {
            submitDetails(values, resetForm);
        },
    });

    useEffect(() => {
        getRoles();
        getParentApi();
    }, []);
    const data = showRoles.map(({ display_name: label, role_id: value }) => ({ label, value }));

    return (

        <div className="px-3 pb-3">
            <React.Fragment>
                <CommonPageHeading heading='Add Service' />
                <FormikProvider value={Formik}>
                    <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange} >
                        <div className="personal-row personal-row1 p">
                            <Row>
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 ">
                                    <Form.Group controlId="serviceName"><Form.Label className="input-lable ">Service Name<font color="red">*</font></Form.Label>
                                        <Field type="text" name="serviceName" maxLength="50" className="input-field form-control"
                                            onKeyPress={(e) => { handleKeyPressAlphabets(e); }}
                                            placeholder="Enter Service Name" />
                                        <ErrorMessage name="serviceName" component="div" className="text-error" /></Form.Group></Col>
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-2">
                                    <div className="input-div position-relative">
                                        <Form.Group controlId="parent">
                                            <Form.Label className="input-lable mb-2">
                                                Parent <font color="red">*</font>
                                            </Form.Label>
                                            <Field as="select" name="parent" className="form-control form-control-md">
                                                <option value="">---Select---</option>
                                                <option value="0">Level 0</option>
                                                {showParent !== undefined && showParent.map((p, i) => {
                                                    return (
                                                        <option key={i} value={p.service_id}>{p.service_name}</option>
                                                    )
                                                })}
                                            </Field>
                                            <ErrorMessage name="parent" component="div" className="text-error" />
                                        </Form.Group>
                                        <IoIosArrowDown className="dropdown-icon" />
                                    </div>
                                </Col>
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                    <Form.Group controlId="priority" >
                                        <Form.Label className="input-lable mb-2">Priority<font color="red">*</font></Form.Label>
                                        <Field
                                            type="text"
                                            name="priority"
                                            className="input-field form-control"
                                        />
                                        <ErrorMessage
                                            name="priority"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                    <Form.Group controlId="target" >
                                        <Form.Label className="input-lable mb-2">Target<font color="red">*</font></Form.Label>
                                        <Field
                                            type="text"
                                            name="target"
                                            className="input-field form-control"
                                        />
                                        <ErrorMessage
                                            name="target"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                    <Form.Group controlId="description" >
                                        <Form.Label className="input-lable mb-2">Description<font color="red">*</font></Form.Label>
                                        <Field
                                            type="text"
                                            name="description"
                                            className="input-field form-control"
                                        />
                                        <ErrorMessage
                                            name="description"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                    <Form.Group controlId="description" >
                                        <Form.Label className="input-lable mb-2">Roles<font color="red">*</font></Form.Label>
                                        <Select name="roles" className='form-control-multi '
                                            options={data}
                                            isMulti
                                            value={selectedOptions}
                                            onChange={(value) => {
                                                setSelectedOptions(value);
                                                Formik.setFieldValue('roles', value.map((option) => option.value));
                                            }}
                                            onSearch={true} placeholder="--Select--"
                                        >
                                        </Select>
                                        <ErrorMessage
                                            name="description"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row></div>
                        <div className="float-end text-end w-100 mb-4 mt-4">
                            <Button variant="success" type="submit" className="submit-btn btn-primary">
                                Submit
                            </Button>
                        </div>

                        <table
                            className="table table-condensed table-bordered table-striped"
                            style={{ border: "1px solid lightblue", borderCollapse: "collapse" }} >
                            <thead>
                                <tr>
                                    <th>Service Id</th>
                                    <th>Service Name</th>
                                    <th>Target</th>
                                    <th>Description</th>
                                    <th></th>
                                    <th></th>
                                    <th>A</th>
                                    <th>D</th>

                                </tr>
                            </thead>
                            <tbody>
                                {showParent !== undefined && showParent.map((p, i) => {
                                    return (<React.Fragment key={i}>
                                        <tr>
                                            <td>{p.service_id}</td>
                                            <td>{p.service_name}</td>
                                            <td>{p.target}</td>
                                            <td>{p.description}</td>
                                            <td align='center'>
                                                <button type='button' className='btn btn-primary btn-sm' onClick={() => { editService(p); }}><FaRegEdit /></button>
                                            </td>
                                            <td align='center'>
                                                <button type='button' className='btn btn-danger btn-sm' onClick={() => { deleteFunction(p); }}><BiTrash /></button>
                                            </td>
                                            <td><button type='button' className='btn btn-danger btn-sm' onClick={() => { DisableFunction(p, true); }}>Activate</button></td>
                                            <td><button type='button' className='btn btn-danger btn-sm' onClick={() => { DisableFunction(p, false); }}>De-Activate</button></td>
                                        </tr>
                                    </React.Fragment>)
                                }
                                )}
                            </tbody>
                        </table>

                    </Form>
                </FormikProvider>
            </React.Fragment>

        </div>
    )
}
